import { render, staticRenderFns } from "./add-source-form.vue?vue&type=template&id=ebb52b74&"
import script from "./add-source-form.vue?vue&type=script&lang=js&"
export * from "./add-source-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports